import React, { useMemo } from 'react';
import clsx from 'clsx';
import { Styled } from './index.styles';
import { HotelInformation } from '../../../molecules/LeftColumn/index';
import { HotelPetPolicy } from '../../../molecules/PetPolicy/index';
import { HotelParking } from '../../../molecules/Parking/index';
import { useCheckBreakpoint } from '../../../hooks';
import { useConditionalPageContextSERP, useConditionalServerDataHotelInformationSERP } from '../../../hooks';
import { hotelInformationMockData } from '../mock/hotelInformation';
import { useConditionalHQVContext } from '../../../hooks/lib/useConditionalHQVContext';
import { useSearchResultsStore } from '../../../modules/store/searchResultsStore';

export const Information: React.FC = () => {
  const { jsonContent } = useConditionalServerDataHotelInformationSERP();
  const { hqvState } = useConditionalHQVContext();
  const modalOpenState = hqvState.modalOpenState;
  const { pageState, isAuthorMode, pageVal } = useConditionalPageContextSERP();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const informationData = useSearchResultsStore((state: { propertyInfoData: any }) => state.propertyInfoData);

  const hotelInformationData = useMemo(() => {
    return pageState?.authorMode || isAuthorMode
      ? hotelInformationMockData.hotelInformationData
      : informationData?.propertyInfoData;
  }, [pageState?.authorMode, informationData, isAuthorMode]);

  const isViewportL = useCheckBreakpoint('viewportL');

  return (
    <Styled>
      <div
        className={clsx(
          pageVal === 'chat' ? (isViewportL ? 'pt-0' : ' px-4 m-0 pt-2') : '',
          'information-component',
          'adjustable-margin-element',
          `${modalOpenState ? 'hqv-modal' : ''}`
        )}
        id="hqv-hotel-info-section"
      >
        <h2
          className={clsx(
            pageVal === 'chat'
              ? 't-subtitle-m mb-3'
              : isViewportL
              ? 't-title-s component-heading'
              : 't-subtitle-xl component-heading'
          )}
        >
          {jsonContent?.propertyInformationLabel}
        </h2>
        <div className="component-content">
          <HotelInformation hotelInformationData={hotelInformationData} />
          <HotelPetPolicy hotelInformationData={hotelInformationData} />
          {hotelInformationData?.property?.parking?.length !== 0 && (
            <HotelParking hotelInformationData={hotelInformationData} />
          )}
        </div>
        <div className="component-content-small-screen">
          <div className="left-content">
            <HotelInformation hotelInformationData={hotelInformationData} />
          </div>
          <div className="right-content">
            <HotelPetPolicy hotelInformationData={hotelInformationData} />
            {hotelInformationData?.property?.parking?.length !== 0 && (
              <HotelParking hotelInformationData={hotelInformationData} />
            )}
          </div>
        </div>
      </div>
    </Styled>
  );
};
